export default __webpack_public_path__ + "static/media/flha.555a6d69.png";